// extracted by mini-css-extract-plugin
export default {"socialContainer":"social_socialContainer__BOUZ0","socialsection":"social_socialsection__Dxh4a"};